module.exports = __webpack_public_path__ + "static/media/menu-back.682d98e0.svg";